module.exports = __webpack_public_path__ + "img/linkedInIcon.0bd078ea.svg";